/** How far above the latest message (in pixels) the reader has to be before the jump-down button shows. */
const SHOW_FROM = 300;

/** The round "down" button over the thread, as WhatsApp has: shown when scrolled up, or on an older part of it. */
export function showJumpDown(distanceFromBottom: number, historic: boolean): boolean {
  return historic || distanceFromBottom > SHOW_FROM;
}

/** Its count: messages from others that arrived after the last one the reader saw at the bottom. */
export function newBelow(messages: { seq: number; sender: { principalId: string } | null }[], seenSeq: number | null, me: string | null): number {
  if (seenSeq == null) return 0;
  return messages.filter((m) => m.seq > seenSeq && m.sender?.principalId !== me).length;
}
